import { gql, useMutation } from '@apollo/client';
import { useCallback, useState } from 'react';
import { IAbandonedBusinessSelection } from '../../interfaces/abandoned-business/IAbandonedBusinessSelection';

type SubmitState =
  | { status: 'idle' }
  | { status: 'submitting' }
  | { status: 'success' }
  | { status: 'error'; message: string };

const CONFIRM_FRIDGE_VISIT_RECOVERY = gql`
  mutation ConfirmFridgeVisitRecoveryMutation(
    $input: ConfirmFridgeVisitRecoveryInput!
  ) {
    confirmFridgeVisitRecovery(input: $input) {
      message
      status
      statusCode
      error
      data
    }
  }
`;

const useAbandonedBusinessSubmit = (token: string) => {
  const [state, setState] = useState<SubmitState>({ status: 'idle' });
  const [confirmRecovery] = useMutation(CONFIRM_FRIDGE_VISIT_RECOVERY);

  const submit = useCallback(
    async (selection: IAbandonedBusinessSelection) => {
      setState({ status: 'submitting' });
      try {
        const res = await confirmRecovery({
          variables: {
            input: {
              token,
              selectedDishes: selection.selectedDishes,
              didNotTakeAnything: selection.didNotTakeAnything,
              comment: selection.comment || undefined,
            },
          },
        });

        const apiResult = res?.data?.confirmFridgeVisitRecovery;
        if (!apiResult?.data) {
          throw new Error(
            apiResult?.message || 'Submission failed. Please try again.',
          );
        }

        setState({ status: 'success' });
      } catch (e: any) {
        setState({
          status: 'error',
          message: e?.message || 'Submission failed. Please try again.',
        });
      }
    },
    [token, confirmRecovery],
  );

  return { submit, state };
};

export default useAbandonedBusinessSubmit;

